import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export const routes = [
  {
    path: "",
    redirect: "/home",
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
    },
    component: () => import("../pages/login/index.vue"),
  },
  {
    path: "/home",
    meta: {
      title: "首页",
    },
    component: () => import("../components/layout.vue"),
    children: [
      {
        path: "",
        name: "home",
        meta: {
          title: "首页",
        },
        component: () => import("../pages/home/index.vue"),
      },
      {
        path: "/home/sdsq",
        name: "sdsq",
        meta: {
          title: "首页",
        },
        component: () => import("../pages/home/sdsq/index.vue"),
      },
      {
        path: "/home/notice",
        name: "notice",
        meta: {
          title: "通知公告",
        },
        component: () => import("../pages/notice/index.vue"),
      },
      {
        path: "/home/bjdl",
        name: "bjdl",
        meta: {
          title: "通知公告",
        },
        component: () => import("../pages/notice/bjdl.vue"),
      },
      {
        path: "/home/regulations",
        name: "regulations",
        meta: {
          title: "大赛章程",
        },
        component: () => import("../pages/regulations.vue"),
      },
      {
        path: "/home/contactUs",
        name: "contactUs",
        meta: {
          title: "联系我们",
        },
        component: () => import("../pages/contactUs.vue"),
      },
      {
        path: "/home/matchMaterials",
        name: "matchMaterials",
        meta: {
          title: "竞赛资料",
        },
        component: () => import("../pages/matchMaterials.vue"),
      },
      {
        path: "/home/partner",
        name: "partner",
        meta: {
          title: "合作伙伴",
        },
        component: () => import("../pages/partner.vue"),
      },
      {
        path: "/home/organization",
        name: "organization",
        meta: {
          title: "组织机构",
        },
        component: () => import("../pages/organization.vue"),
      },
      {
        path: "/home/competition/:cid",
        name: "competition",
        meta: {
          title: "比赛详情",
        },
        component: () => import("../pages/competition/index.vue"),
      },
      {
        path: "/home/activity/:aid",
        name: "activity",
        meta: {
          title: "活动详情",
        },
        component: () => import("../pages/activity/activity.vue"),
      },
      {
        path: "/home/gcompetition/:aid",
        name: "gcompetition",
        meta: {
          title: "通用赛事详情",
        },
        component: () => import("../pages/gCompetition/competition.vue"),
      },
      {
        path: "/home/teamRaces/:tid",
        name: "teamRaces",
        meta: {
          title: "团队赛事",
        },
        component: () => import("../pages/teamRaces/index.vue"),
      },
      {
        path: "/home/teamRacesDetail/:cid",
        name: "teamRacesDetail",
        meta: {
          title: "团队赛事",
        },
        component: () => import("../pages/teamRaces/detail.vue"),
      },
    ],
  },
];

const createRouter = () =>
  new VueRouter({
    routes,
  });

const router = createRouter();

// export function resetRouter() {
//   const newRouter = createRouter()
// }

export default router;
